import {createAsyncThunk} from '@reduxjs/toolkit';
import Api, {ApiMethods} from '../../../middleware/api';
import {notify} from '../../../modules/notifier/services/actions';
import {ProjectDto} from '../../../dto/ProjectDto';

export const getProjects = createAsyncThunk(
    'projects/getProjects',
    async (_, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'project/settings',
            method: ApiMethods.GET
        });
        if (httpStatus === 200) {
            return responseData as ProjectDto[];
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);

export const updateProject = createAsyncThunk(
    'projects/updateProject',
    async (project: ProjectDto, {dispatch, rejectWithValue, requestId}) => {
        const {httpStatus, responseData} = await Api.fetch({
            endpoint: 'project/settings/update',
            method: ApiMethods.POST,
            body: project
        });
        if (httpStatus === 200) {
            dispatch(notify({message: 'Success', key: requestId, variant: 'success'}));
            return project;
        }
        dispatch(notify({message: responseData.message, key: requestId, variant: 'error'}));
        return rejectWithValue(responseData);
    }
);
